module.exports = __webpack_public_path__ + "static/media/thumb.0ed40984.jpg";